import { authenticatedInstance } from '../index/index.service';
import { extractServiceErrorMessage } from '../shared/service-error.util';
import type { OntopoCallLogsPage, OntopoCallLogsQuery } from 'shared-models/browser';

export type {
  OntopoActivityMethod,
  OntopoCallDirection,
  OntopoCallLogView,
  OntopoCallLogsPage,
  OntopoCallLogsQuery,
  OntopoCallStatus,
} from 'shared-models/browser';

class AdminOntopoService {
  async list(query: OntopoCallLogsQuery = {}): Promise<OntopoCallLogsPage> {
    try {
      const response = await authenticatedInstance.get<OntopoCallLogsPage>('/ontopo/call-logs', { params: query });
      return response.data;
    } catch (error: unknown) {
      throw new Error(extractServiceErrorMessage(error, 'טעינת מעקב אונטופו נכשלה'));
    }
  }
}

export const adminOntopoService = new AdminOntopoService();
